module.exports = __webpack_public_path__ + "img/strip_head_b+.7a660264.jpg";